import { useState, useEffect } from 'react'

import { familyGroupService } from '../services'

const useFamilyGroupForm = () => {
  const [data, setData] = useState<any[] | null>(null)
  const [family, setFamily] = useState<any>({})

  useEffect(() => {
    getRelationships()
  }, [])

  const getRelationships = async () => {
    const resp = await familyGroupService.getRelationships()
    setData(resp.data && resp.data.typeRelationship ? resp.data.typeRelationship : [])
  }

  const getFamily = async (documentTypeId: string, documentNumber: string) => {
    const resp = await familyGroupService.getFamily(documentTypeId, documentNumber)
    setFamily(resp.data && resp.data.patient ? resp.data.patient : {})
  }

  return {
    data,
    family,
    getFamily,
    getRelationships
  }
}

export { useFamilyGroupForm }